<div class="main flex flex-row justify-between items-center">
  <div class="flex flex-row items-center justify-start gap-[1.25rem]">
    <div class="org-logo-wrapper">
      <img class="org-logo" [src]="organization.logo" alt="organization logo" #logo
           (error)="logo.src=errorImageLink">
    </div>
    <div class="flex start-flex flex-row items-center justify-start">
      @if (organization.name) {
        <div class="flex flex-col items-start w-[15rem] gap-[0.25rem]">
          <span class="font-4 bold500 opacity0p64">Organization</span>
          <span class="font-3">{{organization.name}}</span>
        </div>
      }
    </div>
  </div>
  <div class="flex flex-row items-center justify-start gap-[0.5rem]">
    @if (organization.webSiteLink) {
      <app-button
        data-qa="website-button"
        [size]="'small'"
        [type]="'grey'"
        [iconName]="'planet.svg'"
        (buttonClick)="goToOrgWebSite()">Website
      </app-button>
    }
    @if (isOrgAdmin) {
      <app-button
        data-qa="edit-org-info-button"
        [size]="'small'"
        [type]="'grey'"
        [iconName]="'edit.svg'"
        (buttonClick)="editOrg.emit(organization)">Edit
      </app-button>
    }
    @if (isOrgAdmin || isAbleToManageUsers) {
      <app-button
        data-qa="plus-member-button"
        [size]="'small'"
        [type]="'accent'"
        [iconName]="'plus.svg'"
        (buttonClick)="onInviteMember()">Member
      </app-button>
    }
  </div>
</div>
